import styled from '@emotion/styled';
import { Box } from '@mui/material';
import {
  BASE_FIELD_BACKGROUND_COLOR,
  BASIC_BORDER_COLOR,
  BASIC_BORDER_RADIUS,
  MEDIUM_EMPHASIS,
} from '../../themes/tokens';
import { Typography } from '@mui/material/';

export const InfoItemWrapper = styled(Box)`
  padding: 14px 16px 11px 16px;
`;

export const StyledSubTitle = styled(Typography)`
  color: ${MEDIUM_EMPHASIS};
  letter-spacing: 0.5px;
`;

export const InfoBlockWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  padding: 8px;
  margin-top: 24px;
  margin-bottom: 24px;
  border-radius: ${BASIC_BORDER_RADIUS};
  border: 1px solid ${BASIC_BORDER_COLOR};
  background-color: ${BASE_FIELD_BACKGROUND_COLOR};
  backdrop-filter: blur(7px);

  hr {
    width: 100%;
  }
`;
